import { CardActions, CardActionsProps, SxProps, Theme } from '@mui/material';

import { appCardActionsSx } from './app-card-styles';

/**
 * Bottom action row (primary/secondary buttons, menus). Pinned after content with spacing defaults.
 */
export function AppCardActions({ sx, ...props }: CardActionsProps) {
  return (
    <CardActions
      {...props}
      sx={
        [
          appCardActionsSx,
          ...(sx !== undefined ? (Array.isArray(sx) ? sx : [sx]) : []),
        ] as SxProps<Theme>
      }
    />
  );
}
